var updateTransformer = function updateTransformer(transformer) {
  /*
      NOTE: Have to write this terrible code because of the Konva issue.
      The bug is that in some cases transformer draws under the base group and becomes invisible
    */
  setTimeout(function () {
    var _transformer$getChild;

    (transformer === null || transformer === void 0 ? void 0 : (_transformer$getChild = transformer.getChildren()) === null || _transformer$getChild === void 0 ? void 0 : _transformer$getChild.length) && (transformer === null || transformer === void 0 ? void 0 : transformer.forceUpdate());
  });
  return transformer;
};
var updateTransformerImmediately = function updateTransformerImmediately(transformer) {
  transformer.forceUpdate();
};

export { updateTransformer, updateTransformerImmediately };
